import { Itinerary } from './../itineray.model';
import { Component, OnInit, Input } from '@angular/core';
import { PartnerData } from '../partner.model';
import { ItineraryService } from '../itinerary.service';

@Component({
  selector: 'app-itinerary-settings-general',
  templateUrl: './itinerary-settings-general.component.html',
  styleUrls: ['./itinerary-settings-general.component.css']
})
export class ItinerarySettingsGeneralComponent implements OnInit {

  @Input()
  itinerary: Itinerary;

  partnersData = PartnerData.values();

  constructor(public itineraryService: ItineraryService) { }

  ngOnInit() {
  }

}
